import React from 'react';
import './LegalPages.css'; // Shared CSS file

function PrivacyPolicy() {
  return (
    <div className="legal-container">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last Updated: March 22, 2025</p>
      
      <p>
        At RemFee, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website remfee.com, including any other media form, media channel, mobile website, or mobile application related or connected thereto (collectively, the "Site"). Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.
      </p>
      
      <h2>Information We Collect</h2>
      
      <h3>Personal Data</h3>
      <p>
        We may collect personal identification information from you in a variety of ways, including, but not limited to, when you visit our site, register on the site, fill out a form, and in connection with other activities, services, features or resources we make available on our Site. You may be asked for, as appropriate:
      </p>
      <ul>
        <li>Email address</li>
        <li>Name (optional)</li>
        <li>Amazon store name (optional)</li>
      </ul>
      
      <h3>Usage Data</h3>
      <p>
        We may also collect information about how the Site is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
      </p>
      
      <h3>Calculation Data</h3>
      <p>
        When you use our Amazon FBA Removal Fee Calculator, we collect the data you input, such as ASINs, product dimensions, weights, and quantities. This information is used to provide you with accurate fee calculations and may be stored in your calculation history if you are a registered user.
      </p>
      
      <h2>How We Use Your Information</h2>
      <p>We use the information we collect in various ways, including to:</p>
      <ul>
        <li>Provide, operate, and maintain our website</li>
        <li>Improve, personalize, and expand our website</li>
        <li>Understand and analyze how you use our website</li>
        <li>Develop new products, services, features, and functionality</li>
        <li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
        <li>Send you emails</li>
        <li>Find and prevent fraud</li>
      </ul>
      
      <h2>Cookies and Tracking Technologies</h2>
      <p>
        We use cookies and similar tracking technologies to track the activity on our Site and hold certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device.
      </p>
      <p>
        You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.
      </p>
      
      <h2>Third-Party Services</h2>
      <p>
        We may use third-party service providers to monitor and analyze the use of our Site, including:
      </p>
      <ul>
        <li>Google Analytics</li>
        <li>Firebase</li>
        <li>Hotjar</li>
      </ul>
      <p>
        These services may collect information sent by your browser as part of a web page request, including your IP address or other identifiers, browser information, and other details about your visit to our Site. Please refer to their respective privacy policies for more information.
      </p>
      
      <h2>Data Security</h2>
      <p>
        We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure. Although we will do our best to protect your personal information, transmission of personal information to and from our Site is at your own risk.
      </p>
      
      <h2>Your Data Protection Rights</h2>
      <p>
        Depending on your location, you may have the following data protection rights:
      </p>
      <ul>
        <li>The right to access, update or delete the information we have on you</li>
        <li>The right of rectification - the right to have your information corrected if it is inaccurate or incomplete</li>
        <li>The right to object to our processing of your personal data</li>
        <li>The right of restriction - the right to request that we restrict the processing of your personal information</li>
        <li>The right to data portability - the right to be provided with a copy of your personal data in a structured, machine-readable and commonly used format</li>
        <li>The right to withdraw consent at any time where we relied on your consent to process your personal information</li>
      </ul>
      <p>
        To exercise any of these rights, please contact us at support@tech-einc.com.
      </p>
      
      <h2>Children's Privacy</h2>
      <p>
        Our Site is not intended for children under the age of 13. We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you are aware that your child has provided us with personal data, please contact us.
      </p>
      
      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date at the top of this Privacy Policy. You are advised to review this Privacy Policy periodically for any changes.
      </p>
      
      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at support@tech-einc.com.
      </p>
    </div>
  );
}

export default PrivacyPolicy; 